export default "__VITE_ASSET__DQbOA7WS__"